<template>
    <div class="row my-2">
        <div class="col-12 col-md-6 mt-2">
            <label class="akkurate-dark small" for="date">From Date</label>
            <b-form-group label-for="start_date" class="akkurate-dark">
                <b-form-input id="start_date" class="mt-1 field-container fields" type="date" v-model="retrive_form.start_date">
                </b-form-input>
            </b-form-group>
        </div>

        <div class="col-12 col-md-6 mt-2">
            <label class="akkurate-dark small" for="date">To Date</label>
            <b-form-group label-for="end_date" class="akkurate-dark">
                <b-form-input id="end_date" class="mt-1 field-container fields" type="date" v-model="retrive_form.end_date">
                </b-form-input>
            </b-form-group>
        </div>
        <div class="col-12 col-md-6 mt-2">
            <label class="akkurate-dark small d-none d-lg-block" for="type">Select Imports</label>
            <multiselect class="mt-1 field-container" v-model="retrive_form.excel_import" :options="excel_import_option"
                :searchable="true" :loading="isSearching" :internal-search="false" :clear-on-select="false"
                :close-on-select="true" :show-no-results="false" :hide-selected="true" label="ref" track-by="id"
                placeholder="Type to search imports..." @search-change="asyncFind">

                <template #noResult>
                    <span>No imports found. Try a different search term.</span>
                </template>
            </multiselect>
        </div>
    </div>


</template>


<script>
import Multiselect from 'vue-multiselect'
export default {
    props: ["excel_import_option", "retrive_form","isSearching","asyncFind"],
    components: {
        Multiselect
    }

}
</script>